import * as config from '../config/config';
import axios from 'axios';
import {
    jsonToQueryStr,
    GET,
    simplesleep,
    __DEV__,
    POST,
} from '../helpers/simpleHelper';
import { appAccessToken, appGetLocale, appGetLoginInfo, appSaveLoginInfo } from '../helpers/appHelper';

async function fetchData({ path = '', type = '', token = '', method = GET, body = {}, response_type }) {
    let url = config.server.url + path;
    let has_param = url.split('?').length > 1;
    let req_body;

    url = url + (!has_param ? '?' : '&') + 'lang=' + appGetLocale();

    if (type === 'multipart/form-data') {
        req_body = body;
    } else {
        req_body = Array.isArray(body) ? [...body] : { ...body };

        if (type.includes('form')) {
            req_body = jsonToQueryStr(req_body);
        } else {
            req_body = JSON.stringify(req_body);
        }
    }

    const headers = { Authorization: token ? 'bearer ' + token : undefined, 'Content-Type': type || 'application/json' };

    const response = await axios({
        headers,
        method,
        url,
        data: req_body,
        responseType: response_type,
        validateStatus: () => true,
    });

    if (!response.data) return {};

    try {
        const code = response.status;

        if (code >= 200 && code <= 299) {
            return response.data;
        } else {
            let responseJson = response.data;

            responseJson.fail = true;

            const expect_path = ['/oauth/token'];

            if (code == 401 && !expect_path.includes(path)) {
                if (__DEV__) console.log('INVALID TOKEN', path, 'code ' + code, responseJson);

                const { access_token: login_access_token, outdated_access_token: login_outdated_access_token } = appGetLoginInfo();

                if (token === login_outdated_access_token) {
                    if (__DEV__) console.log('Using Outdated access token ', path);
                    return await fetchData({ path, type, token: login_access_token, method, body });
                }

                //_________________________________________________________________________________________
                //排隊做refresh
                while (global.refreshing_token) {
                    await simplesleep(500);
                    if (__DEV__) console.log('waiting refresh token.....' + path);
                }

                const {
                    access_token: login_access_token_after_waiting,
                    outdated_access_token: login_outdated_access_token_after_waiting,
                } = appGetLoginInfo();
          
                if (token === login_outdated_access_token_after_waiting) {
                    if (__DEV__) console.log('Using Outdated access token after waiting.....' + path);
                    return await fetchData({ path, type, token: login_access_token_after_waiting, method, body });
                }

                global.refreshing_token = true;

                //_________________________________________________________________________________________

                await simplesleep(500);

                const loginInfo = await postLoginByRefreshToken({});

                global.refreshing_token = false;

                if (!loginInfo.fail) {
                    appSaveLoginInfo(loginInfo);

                    return await fetchData({ path, type, token: loginInfo.access_token, method, body });
                } else {
                    if (__DEV__) console.log('ReLogin LoginByRefreshToken fail FORCE LOGOUT HERER!', path);
                    responseJson = { list: [] };
                }
            }

            if (__DEV__) console.log('fetch fail: path', path, 'code', code);
            if (__DEV__) console.log('fetch fail: path ' + path + ' responseJson', responseJson);

            return responseJson;
        }
    } catch (error) {
        return { fail: true, message: response.data };
    }
}

export const postLogin = async (action) => {
    const path = '/oauth/token';

    const method = POST;

    const type = 'application/x-www-form-urlencoded';

    const token = null;

    const body = {
        client_id: config.server.client_id,
        client_secret: config.server.client_secret,
        grant_type: 'client_credentials',
    };

    const result = await fetchData({ path, token, type, method, body });

    if (!result.fail) {
        appSaveLoginInfo(result);
    }

    // console.log('postLogin', result)

    return result;
};

export const postLoginByRefreshToken = async (action) => {
    const outdated_access_token = appAccessToken();

    const login_result = await postLogin()

    if (!login_result.fail){
        appSaveLoginInfo({ ...login_result, outdated_access_token });
    }

    if (__DEV__) console.log('LoginByRefreshToken', login_result)

    return { ...login_result }
};

export const getHomeNews = async (action) => {
    const path = '/api/web/news/all';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getHomeNews', result)

    return result;
};

export const getProducts = async (action) => {
    const { category_id = '' } = action;

    const path = '/api/web/products/all' + (category_id ? '?catagory_id=' + category_id : '');//catagory_id 係backend串錯

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getProducts', result)

    return result;
};

export const getProductCategories = async (action) => {
    const path = '/api/web/products/categories';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getProductCategories', result)

    return result;
};

export const getPromotions = async (action) => {
    const path = '/api/web/promotions/all';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getPromotions', result)

    return result;
};

export const getShops = async (action) => {
    const path = '/api/web/shops/all';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getShops', result)

    return result;
};

export const getWebOptions = async (action) => {
    const path = '/api/web/options';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getWebOptions', result)

    return result;
};

export const getRecruitNews = async (action) => {
    const path = '/api/web/recruitment/news/all';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getRecruitNews', result)

    return result;
};

export const getRecruitJobs = async (action) => {

    const { job_nature = '' } = action;

    const path = '/api/web/recruitment/jobs/all' + (job_nature ? '?job_nature=' + job_nature : '');

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getRecruitJobs', result)

    return result;
};

export const getRecruitJobsMetaData = async (action) => {

    const path = '/api/web/recruitment/application/form/meta';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getRecruitJobsMetaData', result)

    return result;
};

export const postRecruit = async (action, act) => {
    const { files } = action;

    const token = appAccessToken();

    const path = '/api/web/recruitment/application/apply';

    const method = POST;

    if (files) {
        const uploaded_file = await uploadRecruitFile({ files });
        if (!uploaded_file.fail) {
            action.document_paths = uploaded_file.paths;
            delete action.files;
        } else {
            return { ...uploaded_file };
        }
    }

    // console.log('postRecruit', action)

    const body = { ...action };

    const result = await fetchData({ path, method, token, body });

    //console.log('postRecruit', result)

    return result;
};

export const uploadRecruitFile = async (action) => {
    const { files } = action;

    const path = '/api/web/recruitment/application/documents/upload';

    const type = 'multipart/form-data';

    const method = POST;

    const token = appAccessToken();

    const body = new FormData();

    files.forEach(file => {
        body.append('file', file);
    });

    const result = await fetchData({ path, token, type, method, body });

    // console.log('uploadRecruitFile', result);

    return { ...result };
};

export const getRecipes = async (action) => {
    const path = '/api/web/recipes/all';

    const method = GET;

    const token = appAccessToken();

    const result = await fetchData({ path, method, token });

    // console.log('getRecipes', result)

    return result;
};